import React from 'react';
import { Rss, Plus, Trash2 } from 'lucide-react';
import ProcessingButton from './ProcessingButton';

const RSSFeedsInput = ({ 
  rssFeeds, 
  onAddFeed, 
  onUpdateFeed, 
  onRemoveFeed, 
  onUploadFeeds, 
  isUploading 
}) => {
  return (
    <div className="space-y-4">
      {rssFeeds.map((feed, index) => (
        <div key={index} className="flex items-center gap-2">
          <input
            type="url"
            value={feed}
            onChange={(e) => onUpdateFeed(index, e.target.value)}
            placeholder="https://example.com/rss-feed"
            className="flex-1 p-3 border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-800 text-gray-900 dark:text-white"
          />
          {rssFeeds.length > 1 && (
            <button
              onClick={() => onRemoveFeed(index)}
              className="p-2 text-red-500 hover:bg-red-100 dark:hover:bg-red-900/20 rounded"
            >
              <Trash2 className="w-4 h-4" />
            </button>
          )}
        </div>
      ))}
      
      <div className="flex gap-2">
        <button
          onClick={onAddFeed}
          className="flex items-center gap-2 text-blue-600 hover:text-blue-700"
        >
          <Plus className="w-4 h-4" />
          Add Feed
        </button>
        
        <ProcessingButton
          onClick={onUploadFeeds}
          disabled={isUploading || rssFeeds.every(feed => !feed.trim())}
          isLoading={isUploading}
          loadingText="Processing..."
          variant="warning"
          className="ml-auto"
        >
          Add RSS Feeds
        </ProcessingButton>
      </div>
    </div>
  );
};

export default RSSFeedsInput;
